import { WALMART_PRODUCT_INFORMATION } from './constants';

export const addValueToSchemaProps = (schemaProps, dataObj) => {
  if (!Array.isArray(schemaProps) || !dataObj || typeof dataObj !== 'object') {
    return schemaProps;
  }

  return schemaProps
    .map((schemaProp) => {
      const key = schemaProp.key;
      const value = dataObj[key];

      if (value === undefined) {
        return null;
      }

      const result = { ...schemaProp };

      if (
        schemaProp.type === 'object' &&
        typeof value === 'object' &&
        !Array.isArray(value)
      ) {
        if (
          schemaProp.childProperties &&
          schemaProp.childProperties.length > 0
        ) {
          result.childProperties = addValueToSchemaProps(
            schemaProp.childProperties,
            value
          );
          result.childProperties = result.childProperties.filter(
            (item) => item !== null
          );
        }
        result.value = value;
      } else if (schemaProp.type === 'array' && Array.isArray(value)) {
        result.value = value;

        if (
          schemaProp.items &&
          schemaProp.items.type === 'object' &&
          schemaProp.items.childProperties
        ) {
          result.items = { ...schemaProp.items };
          result.items.childProperties = value
            .map((item) => {
              if (typeof item === 'object' && !Array.isArray(item)) {
                return addValueToSchemaProps(
                  schemaProp.items.childProperties,
                  item
                );
              }
              return null;
            })
            .filter((item) => item !== null);
        }
      } else {
        result.value = value;
      }

      return result;
    })
    .filter((item) => item !== null);
};

export const mergeDataToSchema = (schema, data) => {
  if (!data?.data) return null;

  const [schemaData] = schema || [];

  const result = {};

  schemaData.productProperties.forEach((schemaProp) => {
    const key = schemaProp.key;
    const dataValue = data?.data[key];

    if (dataValue === undefined) {
      return;
    }

    result[key] = { ...schemaProp };

    if (
      schemaProp.type === 'object' &&
      typeof dataValue === 'object' &&
      !Array.isArray(dataValue)
    ) {
      if (schemaProp.childProperties && schemaProp.childProperties.length > 0) {
        result[key].childProperties = addValueToSchemaProps(
          schemaProp.childProperties,
          dataValue
        );
      }
    } else if (schemaProp.type === 'array' && Array.isArray(dataValue)) {
      result[key].value = dataValue;
      if (schemaProp.items && schemaProp.items.childProperties) {
        result[key].items = { ...schemaProp.items };
        result[key].items.childProperties = dataValue
          .map((item) => {
            if (typeof item === 'object' && !Array.isArray(item)) {
              return addValueToSchemaProps(
                schemaProp.items.childProperties,
                item
              );
            }
            return null;
          })
          .filter((item) => item !== null);
      }
    } else {
      result[key].value = dataValue;
    }
  });

  return {
    productId: data.productId,
    needToRepublish: data.needToRepublish,
    data: result,
  };
};

export const transformChildProperties = (childProperties) => {
  if (!childProperties || childProperties.length === 0) {
    return [];
  }

  return childProperties.map((child) => {
    const transformed = {
      propertyName: child.key,
      propertyDisplayName: child.title,
      propertyDescription: child.description || '',
      propertyType: child.type || 'string',
      isArray: child.type === 'array',
      listName: child.enums && child.enums.length > 0 ? `${child.key}Enum` : '',
      propertyGroup: null,
      fieldFullPath: `${
        WALMART_PRODUCT_INFORMATION.moduleName + '.' + child?.fullKey
      }`,
      childProperties: [],
    };

    if (
      child.type === 'object' &&
      child.childProperties &&
      child.childProperties.length > 0
    ) {
      transformed.childProperties = transformChildProperties(
        child.childProperties
      );
    }

    if (child.type === 'array' && child.items) {
      if (
        child.items.childProperties &&
        child.items.childProperties.length > 0
      ) {
        transformed.propertyType = child.key;
        transformed.childProperties = transformChildProperties(
          child.items.childProperties
        );
      } else {
        transformed.propertyType = child.items.type || 'string';
        if (child.items.enums && child.items.enums.length > 0) {
          transformed.listName = `${child.key}Enum`;
        }
      }
    }

    return transformed;
  });
};

export const transformWalmartModuleToProductModule = (walmartModule) => {
  if (!walmartModule || !walmartModule.moduleProperties) {
    return null;
  }

  const productModule = {
    moduleName: walmartModule.moduleName,
    moduleDisplayName: walmartModule.moduleDisplayName,
    moduleDescription: walmartModule.moduleDescription || '',
    moduleProperties: [],
  };

  productModule.moduleProperties = walmartModule.moduleProperties
    .filter((item) => !!item)
    .map((prop) => {
      const transformedProp = {
        propertyName: prop?.key,
        propertyDisplayName: prop?.title,
        propertyDescription: prop?.description || '',
        propertyType: prop?.type || 'string',
        isArray: prop?.type === 'array',
        listName:
          prop?.enums && prop.enums.length > 0 ? `${prop?.key}Enum` : null,
        propertyGroup: null,
        fieldFullPath: `${
          WALMART_PRODUCT_INFORMATION.moduleName + '.' + prop?.fullKey
        }`,
        childProperties: [],
      };

      if (
        prop.type === 'object' &&
        prop.childProperties &&
        prop.childProperties.length > 0
      ) {
        transformedProp.childProperties = transformChildProperties(
          prop.childProperties
        );
      }

      if (prop.type === 'array' && prop.items) {
        if (
          prop.items.childProperties &&
          prop.items.childProperties.length > 0
        ) {
          transformedProp.propertyType = prop.key.toLowerCase();
          transformedProp.childProperties = transformChildProperties(
            prop.items.childProperties
          );
        } else {
          transformedProp.propertyType = prop.items.type || 'string';
          if (prop.items.enums && prop.items.enums.length > 0) {
            transformedProp.listName = `${prop?.key}Enum`;
          }
        }
      }

      return transformedProp;
    });

  return productModule;
};

export const getPrecisionFromStep = (step) => {
  if (!step) return 0;
  const stepStr = step.toString();
  return stepStr.includes('.') ? stepStr.split('.')[1].length : 0;
};
